module.exports = __webpack_public_path__ + "static/media/dramaImg4.4dd82b56.jpg";